
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.29 9.952h4.327c.321 0 .547-.198.547-.52 0-.307-.219-.505-.54-.505H4.086l1.661-7.725h1.531c.322 0 .547-.198.547-.52 0-.307-.219-.505-.54-.505H2.951c-.321 0-.547.198-.547.506 0 .32.233.52.554.52h1.524l-1.66 7.724H1.282c-.321 0-.54.198-.54.506 0 .32.226.52.547.52z","fill":"#000"}})])
          )
        }
      }
    